import type { InjectionKey, Plugin } from 'vue';
import { inject } from 'vue';
import type { ApiContext } from './adm-api';
import { createAdminApi } from './adm-api';
import type { AxiosInstance } from 'axios';

const apiInjectKey: InjectionKey<ApiContext> = Symbol('api-injection');

export default function createAdmApiPlugin(ai: AxiosInstance): Plugin {
  return {
    install(app) {
      const api = createAdminApi(ai);

      app.provide(apiInjectKey, api);
    }
  };
}
